import { CONSTANTS } from '../../../../constants/constants';
import useHasPermission from '../../../../components/Permissions/useHasPermission';

function useCanManageJiraIntegration() {
  return useHasPermission({
    permission: CONSTANTS.PERMISSIONS.WRITE_ORGCONFIG,
    rbacPermission: CONSTANTS.PERMISSIONS.RBAC_MANAGE_INTEGRATIONS
  });
}

export default useCanManageJiraIntegration;
